export default {
  list({page = 1, sort = 'id_asc', search = ''} = {}) {
    return axios.get(`/analytics-history-groups?page=${page}&sort=${sort}&search=${search}`);
  },

  create(payload) {
    return axios.post('/analytics-history-groups', payload);
  },

  update(id, payload) {
    return axios.put(`/analytics-history-groups/${id}`, payload);
  },

  delete(id) {
    return axios.delete(`/analytics-history-groups/${id}`);
  },
  
  attachToGroup(id, payload) {
    return axios.put(`/analytics-history-groups/${id}/attach`, payload);
  },
  detachFromGroup(id, payload) {
    return axios.put(`/analytics-history-groups/${id}/detach`, payload);
  },
  getReportsInGroup(id, {page = 1, sort = 'id_asc'}) {
    return axios.get(`/analytics-history-groups/${id}/reports?page=${page}&sort=${sort}`);
  }

}
